/**
 * Reference prompt site number from this document
 * https://docs.google.com/presentation/d/1LD3IYDx2lHh-8EL8rqKkNPum67IGmgal0INs6v4cQDo
 */
export enum AuthTrackerIntent {
  /**
   * unknown
   */
  Unknown = 'unknown',

  FilmQuota = 'film-quota',
}
